import { render, staticRenderFns } from "./MasterplanRpSettings.vue?vue&type=template&id=48bf0cc3&"
import script from "./MasterplanRpSettings.vue?vue&type=script&lang=js&"
export * from "./MasterplanRpSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports